/**
 * Logo Component
 *
 * Displays the ConEx 360 logo with optional text label.
 */

import conexLogoLarge from '@/assets/conex-logo-large.png'

interface LogoWithTextProps {
  height?: string
}

export function LogoWithText({ height = 'h-12' }: LogoWithTextProps) {
  return (
    <img
      src={conexLogoLarge}
      alt="ConEx 360"
      className={`${height} w-auto object-contain`}
    />
  )
}
